import React from 'react';
import styled from 'styled-components';

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
`;

const StyledCheckbox = styled.svg.attrs({
  viewBox: '0 0 512 512',
  ['aria-hidden']: 'true',
  focusable: 'false',
})`
  fill: none;
  display: block;
  width: 1.35em;
  height: auto;

  ${HiddenCheckbox}:focus-visible + & {
    outline: 2px solid var(--checkbox-color, var(--color-brand-green-400));
  }

  ${HiddenCheckbox}:disabled + & {
    opacity: 0.5;
  }
`;

const StyledCheckboxCircle = styled.circle.attrs({
  cx: 256,
  cy: 256,
  r: 223,
})`
  fill: var(--color-brand-grey-100);
  stroke: var(--color-brand-grey-400);
  stroke-width: 38;

  ${HiddenCheckbox}:checked + ${StyledCheckbox} > & {
    fill: var(--checkbox-color, var(--color-brand-green-400));
    stroke: var(--checkbox-color, var(--color-brand-green-400));
  }
`;

const StyledCheckboxMark = styled.path.attrs({
  d: 'M174.5 246.5L233.5 318.5L344 211.5',
})`
  stroke: var(--checkbox-mark-color, #fff);;
  stroke-width: 38;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 247;
  stroke-dashoffset: 247;

  ${HiddenCheckbox}:checked + ${StyledCheckbox} > & {
    transition: stroke-dashoffset 250ms ease;
    stroke-dashoffset: 0;
  }
`;

const CheckboxContainer = styled.div`
  position: relative;
`;

const LabelContent = styled.div`
  font-weight: 500;
  color: var(--color-brand-grey-600);

  & a {
    text-decoration: underline;

    &:hover {
      color: var(--checkbox-color, var(--color-brand-green-400));
    }
  }
`;

const Label = styled.label`
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  margin-left: -0.25em;
  margin-right: -0.25em;
  cursor: pointer;
  user-select: none;

  & > ${CheckboxContainer}, & > ${LabelContent} {
    margin-left: 0.25em;
    margin-right: 0.25em;
  }
`;

const Checkbox = ({ className, style, children, ...props }) => (
  <div className={className} style={style}>
    <Label>
      <CheckboxContainer>
        <HiddenCheckbox {...props} />
        <StyledCheckbox>
          <StyledCheckboxCircle />
          <StyledCheckboxMark />
        </StyledCheckbox>
      </CheckboxContainer>
      <LabelContent>{children}</LabelContent>
    </Label>
  </div>
);

export default Checkbox;
